import axios from "axios";

const instance = axios.create({
  // baseURL: 'https://identitytoolkit.googleapis.com/v1'

  // baseURL: "http://localhost:3020/api/",

  // baseURL: "http://3.12.172.16:3020/api/",
  // baseURL: "https://api.rabiahostal.com.mx/api/",
  baseURL: "https://backend.nxtagro.io/api/",
});

// instance.defaults.headers.common['SOMETHING'] = 'something'

export default instance;
